import { SHOW_MODAL, HIDE_MODAL, SHOW_PREVIOUS_MODAL } from './types';

const initialState = {
    current: null,
    currentProps: {},
    previous: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SHOW_MODAL:
            return {
                current: action.modalType,
                currentProps: action.modalProps,
                previous: state.current
                    ? [...state.previous, {
                        modalType: state.current,
                        modalProps: state.currentProps,
                    }] : state.previous,
            };
        case HIDE_MODAL:
            return initialState;
        case SHOW_PREVIOUS_MODAL:
            return {
                current: state.previous[state.previous.length - 1].modalType,
                currentProps: state.previous[state.previous.length - 1].modalProps,
                previous: state.previous.slice(0, state.previous.length - 1),
            };
        default:
            return state;
    }
};
